"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorNavigation = void 0;
var tslib_1 = require("tslib");
var answers_ui_libby_1 = require("@wix/answers-ui-libby");
var React = require("react");
var anchor_icon_1 = require("./anchor-icon");
var translations_1 = require("../translations");
var answers_lib_1 = require("@wix/answers-lib");
var calc_direction_1 = require("../../utils/calc-direction");
var answers_experiments_1 = require("@wix/answers-experiments");
var AnchorNavigation = /** @class */ (function (_super) {
    tslib_1.__extends(AnchorNavigation, _super);
    function AnchorNavigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedAnchorId: ''
        };
        return _this;
    }
    AnchorNavigation.prototype.componentDidMount = function () {
        var _this = this;
        var cb = function (anchorId) {
            _this.setState({ selectedAnchorId: anchorId });
        };
        this.props.onAnchorIdChange(cb);
    };
    AnchorNavigation.prototype.render = function () {
        var _this = this;
        var props = this.props;
        // tslint:disable-next-line:max-line-length
        var anchors = (props.components || []).filter(function (c) { return c.type === 'heading' && !!c.value.anchorId; });
        var title = translations_1.componentViewerTranslate(props.locale)("anchor-navigation.title");
        var anchorsComp = anchors.map(function (anchor, idx) {
            var anchorInView = _this.state.selectedAnchorId === anchor.value.anchorId;
            var anchorClass = anchorInView ? 'anchor-in-view' : '';
            var anchorLevel = anchor.value.level;
            var currentUrlWithoutAnchor = window.location.href.replace(/#.*$/, '');
            return (React.createElement("li", { className: "anchor indent-" + anchorLevel, key: idx },
                anchorInView ? React.createElement(answers_ui_libby_1.Icon, { icon: anchor_icon_1.anchorIcon }) : null,
                React.createElement("a", { className: anchorClass, href: answers_experiments_1.isFeatureEnabled('PublicAnchorLinkAsAbsolute') ? currentUrlWithoutAnchor + "#" + anchor.value.anchorId : "#" + anchor.value.anchorId }, anchor.value.text)));
        });
        var direction = calc_direction_1.calcDirection(props.locale);
        return (React.createElement("div", { className: answers_lib_1.classNames('anchor-navigation', direction) },
            React.createElement("div", { className: 'anchor-navigation-title' }, title),
            React.createElement("ul", { className: 'anchor-list' }, anchorsComp)));
    };
    return AnchorNavigation;
}(React.Component));
exports.AnchorNavigation = AnchorNavigation;
//# sourceMappingURL=anchor-navigation.comp.js.map